import type { Dispatch } from "@reduxjs/toolkit";

export const FETCH_CONTRACTSLAS = "FETCH_CONTRACTSLAS";
export const FETCH_CONTRACTSLAS_SUCCESS = "FETCH_CONTRACTSLAS_SUCCESS";
export const FETCH_CONTRACTSLAS_ERROR = "FETCH_CONTRACTSLAS_ERROR";
export const CREATE_CONTRACTSLAS = "CREATE_CONTRACTSLAS";
export const CREATE_CONTRACTSLAS_SUCCESS = "CREATE_CONTRACTSLAS_SUCCESS";
export const CREATE_CONTRACTSLAS_ERROR = "CREATE_CONTRACTSLAS_ERROR";
export const UPDATE_CONTRACTSLAS = "UPDATE_CONTRACTSLAS";
export const UPDATE_CONTRACTSLAS_SUCCESS = "UPDATE_CONTRACTSLAS_SUCCESS";
export const UPDATE_CONTRACTSLAS_ERROR = "UPDATE_CONTRACTSLAS_ERROR";

export function fetchContractSlas() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: FETCH_CONTRACTSLAS,
    });
  };
}
export function createContractSlas(request: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: CREATE_CONTRACTSLAS,
      payload: {
        data: {
          request,
        },
      },
    });
  };
}

export function updateContractSlas(request: unknown) {
  return (dispatch: Dispatch) => {
    dispatch({
      type: UPDATE_CONTRACTSLAS,
      payload: {
        data: {
          request,
        },
      },
    });
  };
}
